/* Shared LUMA storefront language controller. Kept outside Instant's generated files. */
(function () {
  'use strict';
  if (window.LumaLanguage) return;
  const entries = window.LumaTranslations || [];
  const normalise = text => text.replace(/\s+/g, ' ').trim();
  const exact = new Map();
  const patterns = [];
  const escapeRE = text => text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  entries.forEach(entry => {
    Object.values(entry).forEach(source => {
      source = normalise(source);
      if (!source) return;
      if (!source.includes('{{')) {
        if (!exact.has(source)) exact.set(source, entry);
        return;
      }
      if (!/[a-zA-ZåäöæøÅÄÖÆØ]{2}/.test(source.replace(/{{[^}]+}}/g, ''))) return;
      const names = [];
      const pieces = source.split(/({{\s*[^}]+\s*}})/g);
      const regex = pieces.map(piece => {
        if (!piece.startsWith('{{')) return escapeRE(piece);
        names.push(piece.slice(2, -2).trim());
        return '(.+?)';
      }).join('');
      patterns.push({regex: new RegExp('^' + regex + '$'), names, entry});
    });
  });
  function translate(source) {
    const value = normalise(source);
    let entry = exact.get(value), captures = {};
    if (!entry) {
      for (const pattern of patterns) {
        const match = value.match(pattern.regex);
        if (!match) continue;
        entry = pattern.entry;
        pattern.names.forEach((name, i) => { captures[name] = match[i + 1]; });
        break;
      }
    }
    if (!entry) return source;
    const output = entry[language].replace(/{{\s*([^}]+?)\s*}}/g, (token, name) => captures[name] || token);
    return (source.match(/^\s*/) || [''])[0] + output + (source.match(/\s*$/) || [''])[0];
  }
  let language = 'sv';
  try { language = localStorage.getItem('luma-lang') || (/^(nb|nn|no)/i.test(navigator.language) ? 'no' : 'sv'); } catch (_) {
    language = /^(nb|nn|no)/i.test(navigator.language) ? 'no' : 'sv';
  }
  language = language === 'no' ? 'no' : 'sv';
  const roots = new Set();
  const textState = new WeakMap();
  const attrState = new WeakMap();
  let queued = false;
  const attrs = ['aria-label', 'alt', 'title', 'placeholder', 'a11y-prev-slide-message', 'a11y-next-slide-message'];
  const ignored = 'script,style,noscript,textarea,code,pre,[translate="no"],[data-luma-selector],.ic-sv,.ic-no';
  function updateText(node) {
    if (!node.parentElement || node.parentElement.closest(ignored) || !node.nodeValue.trim()) return;
    let state = textState.get(node);
    if (state && state.output === node.nodeValue && state.language === language) return;
    if (!state || node.nodeValue !== state.output) state = {source: node.nodeValue};
    state.output = translate(state.source);
    state.language = language;
    if (node.nodeValue !== state.output) node.nodeValue = state.output;
    textState.set(node, state);
  }
  function updateAttrs(el) {
    if (el.closest('script,style,[translate="no"],[data-luma-selector]')) return;
    let states = attrState.get(el) || {};
    attrs.forEach(attr => {
      if (!el.hasAttribute(attr)) return;
      let state = states[attr];
      const value = el.getAttribute(attr);
      if (!state || value !== state.output) state = {source: value};
      const explicit = attr === 'aria-label' && el.getAttribute('data-aria-' + language);
      state.output = explicit || translate(state.source);
      if (value !== state.output) el.setAttribute(attr, state.output);
      states[attr] = state;
    });
    attrState.set(el, states);
  }
  function addHomeSelector(root) {
    if (!root.host || !root.host.closest('[data-instant-id="wi1zm3DDhiRYBjAv"]') || root.querySelector('[data-luma-selector]')) return;
    const first = root.querySelector('section');
    if (!first) return;
    const style = document.createElement('style');
    style.textContent = '.luma-language-wrap{display:flex;justify-content:flex-end;max-width:1152px;margin:0 auto 20px;padding:0 24px;font:500 13px Poppins,sans-serif;color:#3b2632}.luma-language-picker{display:inline-flex;gap:4px;border:1px solid #ecdfd2;border-radius:999px;padding:4px;background:#faf5ee}.luma-language-picker label{position:relative;cursor:pointer}.luma-language-picker input{position:absolute;width:1px;height:1px;opacity:0}.luma-language-picker span{display:inline-block;padding:7px 16px;border-radius:999px}.luma-language-picker input:checked+span{background:#3b2632;color:#faf5ee}.luma-language-picker input:focus-visible+span{outline:2px solid #3b2632;outline-offset:2px}';
    root.appendChild(style);
    const wrap = document.createElement('div');
    wrap.className = 'luma-language-wrap';
    wrap.setAttribute('data-luma-selector', '');
    wrap.innerHTML = '<div class="luma-language-picker" role="radiogroup" aria-label="Språk"><label><input type="radio" name="ic-lang" class="ic-lang-sv" value="sv"><span lang="sv">Svenska</span></label><label><input type="radio" name="ic-lang" class="ic-lang-no" value="no"><span lang="nb">Norsk</span></label></div>';
    first.prepend(wrap);
  }
  function register(root) {
    if (roots.has(root)) return;
    roots.add(root);
    root.addEventListener('change', event => {
      const input = event.target;
      if (input.matches && input.matches('input[name="ic-lang"]')) setLanguage(input.value);
    });
    const observer = new MutationObserver(schedule);
    observer.observe(root, {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:attrs});
  }
  function discover(root) {
    register(root);
    root.querySelectorAll('*').forEach(el => { if (el.shadowRoot) discover(el.shadowRoot); });
  }
  function sync() {
    queued = false;
    discover(document);
    document.documentElement.lang = language === 'no' ? 'nb' : 'sv';
    document.documentElement.dataset.lumaLang = language;
    roots.forEach(root => {
      if (root.host && !root.host.isConnected) return;
      addHomeSelector(root);
      root.querySelectorAll('input[name="ic-lang"]').forEach(input => { input.checked = input.value === language; });
      root.querySelectorAll('[data-luma-lang]').forEach(el => {
        el.dataset.lumaLang = language;
        el.lang = language === 'no' ? 'nb' : 'sv';
      });
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) updateText(node);
      root.querySelectorAll(attrs.map(attr => '[' + attr + ']').join(',')).forEach(updateAttrs);
    });
    if (window.cartStrings) {
      window.cartStrings.error = language === 'no' ? 'Det oppstod en feil ved oppdatering av handlekurven. Prøv igjen.' : 'Det uppstod ett fel när varukorgen uppdaterades. Försök igen.';
      window.cartStrings.quantityError = language === 'no' ? 'Du kan bare legge til [quantity] av denne varen i handlekurven.' : 'Du kan bara lägga till [quantity] av den här varan i varukorgen.';
    }
    if (window.variantStrings) Object.assign(window.variantStrings, language === 'no' ? {
      addToCart:'Legg i handlekurven',soldOut:'Utsolgt',unavailable:'Ikke tilgjengelig',unavailable_with_option:'[value] – ikke tilgjengelig'
    } : {addToCart:'Lägg i varukorgen',soldOut:'Slutsåld',unavailable:'Inte tillgänglig',unavailable_with_option:'[value] – inte tillgänglig'});
  }
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(sync);
  }
  function setLanguage(value, broadcast = true) {
    language = value === 'no' || value === 'nb' || value === 'nn' ? 'no' : 'sv';
    try { localStorage.setItem('luma-lang', language); } catch (_) {}
    sync();
    if (broadcast) window.dispatchEvent(new CustomEvent('luma:lang', {detail:language}));
  }
  window.LumaLanguage = {set:setLanguage, get:() => language, refresh:schedule};
  window.addEventListener('luma:lang', event => setLanguage(event.detail, false));
  window.addEventListener('storage', event => {
    if (event.key === 'luma-lang') setLanguage(event.newValue, false);
  });
  window.addEventListener('pageshow', schedule);
  document.addEventListener('shopify:section:load', schedule);
  if (window.customElements) customElements.whenDefined('instant-layout').then(schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync, {once:true});
  else sync();
})();
